/**
 * 인증코드 칸 노출 판정 재료 — 응답 행에 `authCode` 키가 하나라도 있는가(값이 null 이어도 키가 있으면 참).
 * china-inapi 는 써마지 문서에만 이 키를 싣는다. CertificateList.vue visibleColumns 에서 쓴다.
 */
export function hasAuthCodeKey(rows) {
  return Array.isArray(rows) && rows.some((r) => r && Object.prototype.hasOwnProperty.call(r, 'authCode'));
}
